import { useContent } from "contexts/contentContext/contentContext.js";

const RecipientInput = ({
  type = "text",
  placeholder,
  value,
  onChange,
  error,
  isActive,
  maxLength,
  currentLength,
  errorMessage,
  index,
}) => {
  const { getTextByKey } = useContent();

  const getErrorMessage = () => {
    if (!errorMessage) {
      if (type === "email") {
        if (error === "invalid") {
          return getTextByKey("invalid-email-text");
        }
        return getTextByKey("set-recipient-email-text");
      }
      return getTextByKey("set-recipient-name-text");
    }
    return errorMessage;
  };

  const getPlaceholder = () => {
    if (!placeholder) {
      if (type === "email") {
        return getTextByKey("recipient-email");
      }
      return `${getTextByKey("field-label-text")} ${index + 1}`;
    }
    return placeholder;
  };

  const handleChange = (e) => {
    const newValue = e.target.value;
    if (!maxLength || newValue.length <= maxLength) {
      onChange(e);
    }
  };

  return (
    <div
      className="input-with-counter"
      style={{ userSelect: "text", WebkitUserSelect: "text" }}
    >
      <input
        type={type}
        placeholder={getPlaceholder()}
        value={value}
        onChange={handleChange}
        maxLength={maxLength}
        className={error ? "error" : "recipient-input"}
        style={{ userSelect: "text", WebkitUserSelect: "text" }}
      />
      <div className="message-container">
        <div
          className={`recipient-error-message ${error ? "error-active" : ""}`}
        >
          {error ? getErrorMessage() : null}
        </div>
        <div className="counter">
          {currentLength} / {maxLength}
        </div>
      </div>
    </div>
  );
};

export default RecipientInput;
